import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchAllRoles = createAsyncThunk('getRolePermission/fetchAllRoles',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosPrivate.get(api.roles.getAll)
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server")
    }
  })

const getRolesPermissionListSlice = createSlice({
  name: 'rolePermission',
  initialState: {
    roles: [],
    Permissions: [],
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchAllRoles.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchAllRoles.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.roles = action.payload
            ?.filter(role => role.roleName !== "SUPER_ADMIN")
            ?.map(role => ({
              ...role,
              roleName: role.roleName
                .replace(/_/g, ' ')               // Swap underscore for space
                .replace(/[^a-zA-Z0-9 ]/g, '')    // Remove special characters
                .replace(/\s+/g, ' ')             // Turn "  " into " " 
                .trim()                           
            }));
        })
      .addCase(fetchAllRoles.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getRolesPermissionListSlice.reducer;